import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68af6e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-item-avatar" }
const _hoisted_2 = { class: "member-item__text-wrap" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title", "innerHTML"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "member-item__bracket"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "member-item__bracket"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 外部 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 禁用 ")
const _hoisted_12 = ["title", "innerHTML"]
const _hoisted_13 = ["title"]


const __default__ = {
  name: 'TeamHeadMemberListItem'
}

import { PropType, computed, ref } from 'vue'
import { NPopover, NAvatar, NButton, NSpace } from 'naive-ui'
import MemberInputEditor from './inputEditor.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    type: Object as PropType<{
      id: number
      avatar: string
      isExternal: boolean
      sign: string
      nickname: string
      roleId: number
      status: number
      disabled: boolean
      userId: number
      user_name: string
      highlightNickname?: string
      highlightSign?: string
      highlightUsername?: string
    }>
  },
  edit: {
    type: Object as PropType<{ type: string; id: number }>,
    default: () => ({})
  },
  isCurrentAccount: {
    type: Boolean,
    default: false
  }
},
  emits: ["inputDone", "contextmenu", "clickItem", "memberLeftClick"],
  setup(__props, { emit }: { emit: ({
  (e: 'inputDone', text: string): void
  (e: 'contextmenu', event: MouseEvent): void
  (e: 'clickItem', event: MouseEvent): void
  (e: 'memberLeftClick'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

_useCssVars(_ctx => ({
  "35c6582e": (_unref(multipleCssType).nameWidth),
  "491ac012": (_unref(multipleCssType).signWidth)
}))



const popover = ref<typeof NPopover | null>(null)
// 当团队昵称为空时，使用真实昵称代替
const displayName = computed(() => {
  return props.item?.nickname ? props.item?.nickname : props.item?.user_name
})
const showInput = computed(() => {
  return props.edit.id === props.item?.id
})
// 是否正在修改昵称
const isEditNickname = computed(() => {
  return props.edit.type === 'nickname'
})
const update = text => {
  emit('inputDone', text)
}
const memberLeftClick = () => {
  emit('memberLeftClick')
}
const memberContextMenu = event => {
  popover.value?.setShow(false)
  emit('contextmenu', event)
}
const clickItem = e => {
  memberLeftClick()
  emit('clickItem', e)
}
// 宽度调整
// 当匹配到真实昵称时，适当减少真实昵称的显示区域的宽度
const multipleCssType = computed(() => {
  if (props.item?.highlightUsername && props.item.nickname) {
    return {
      nameWidth:
        props.isCurrentAccount || props.item?.isExternal || props.item?.disabled
          ? '62px'
          : '90px',
      signWidth:
        props.isCurrentAccount || props.item?.isExternal || props.item?.disabled
          ? '40px'
          : '90px'
    }
  } else {
    return {
      nameWidth:
        props.isCurrentAccount || props.item?.isExternal || props.item?.disabled
          ? '82px'
          : '110px',
      signWidth:
        props.isCurrentAccount || props.item?.isExternal || props.item?.disabled
          ? '60px'
          : '110px'
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "member-item-wrap",
    onContextmenu: memberContextMenu,
    onClick: clickItem
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NAvatar), {
        src: __props.item?.avatar,
        round: "",
        size: 24
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["member-item__text", {
          'member-item__name-hide': _unref(isEditNickname) && __props.edit.id === __props.item?.id
        }])
      }, [
        (!__props.item?.highlightNickname && !__props.item?.highlightUsername)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "member-item_name",
              title: _unref(displayName)
            }, _toDisplayString(_unref(displayName)), 9, _hoisted_3))
          : _createCommentVNode("", true),
        (__props.item?.highlightNickname)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "member-item_name match-highlight",
              title: _unref(displayName),
              innerHTML: __props.item?.highlightNickname
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (__props.item?.highlightUsername && __props.item.nickname)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "match-username-prefix",
              title: _unref(displayName)
            }, _toDisplayString(_unref(displayName)), 9, _hoisted_5))
          : _createCommentVNode("", true),
        (__props.item?.highlightUsername)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              title: __props.item?.user_name,
              class: "member__match-username-wrap"
            }, [
              (__props.item?.highlightUsername && __props.item.nickname)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString('('), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "member-item_name match-highlight",
                innerHTML: __props.item?.highlightUsername
              }, null, 8, _hoisted_8),
              (__props.item?.highlightUsername && __props.item.nickname)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(')')))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          style: _normalizeStyle({ display: __props.isCurrentAccount ? 'block' : 'none' }),
          class: "member-item__nickname-suffix"
        }, _toDisplayString('(我)'), 5),
        _createVNode(_unref(NSpace), {
          size: 4,
          class: "member-item__tag",
          inline: "",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (__props.item?.isExternal)
                ? (_openBlock(), _createBlock(_unref(NButton), {
                    key: 0,
                    secondary: "",
                    round: "",
                    type: "info",
                    class: "member-item__tag-item"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (__props.item?.disabled)
                ? (_openBlock(), _createBlock(_unref(NButton), {
                    key: 0,
                    secondary: "",
                    round: "",
                    type: "error",
                    class: "member-item__tag-item"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["member-item__sign-wrap", {
        'member-item__sign-hide': __props.edit.type === 'sign' && __props.edit.id === __props.item?.id
      }])
    }, [
      (__props.item?.highlightSign)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "member-item__sign match-highlight",
            title: __props.item?.sign,
            innerHTML: __props.item?.highlightSign
          }, null, 8, _hoisted_12))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            title: __props.item?.sign,
            class: "member-item__sign"
          }, _toDisplayString(__props.item?.sign), 9, _hoisted_13))
    ], 2),
    (_unref(showInput))
      ? (_openBlock(), _createBlock(MemberInputEditor, {
          key: 0,
          class: _normalizeClass(["member-item__editor", `member-item__editor-${_unref(isEditNickname) ? 'left' : 'right'}`]),
          text: _unref(isEditNickname) ? __props.item?.nickname : __props.item?.sign,
          placeholder: _unref(isEditNickname) ? '请输入团队内昵称' : '请输入个性签名',
          maxlength: 15,
          onUpdate: update
        }, null, 8, ["class", "text", "placeholder"]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})